export default __webpack_public_path__ + "static/media/goFetch-logo.e9b09a5c.png";